import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    payment: {
        width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    amount: {
        width: '35%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    type: {
        width: '25%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
  });

  const ReceiptTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.payment}>Payment</Text>
        <Text style={styles.payment}>Date</Text>
        <Text style={styles.type}>Type</Text>
        <Text style={styles.amount}>Amount</Text>
    </View>
  );
  
  export default ReceiptTableHeader